import { createRoot } from 'react-dom/client';
import "@fg/design-system/css/main.min.css";
import "@fg/design-system/theming/default-theme.css";
import "@fg/design-system/theming/default-theme-dark.css";
import App from './App';
import { initPiwik } from 'utils/piwikUtils';
import { getOriginalUrlFromHref } from 'services/configService';
import {
    applyRestoreUrl,
    getPostAuthRestoreUrl,
} from 'services/authStateRestore';

const originalUrl = getOriginalUrlFromHref(window.location.href);
const restoreUrl = originalUrl ? null : getPostAuthRestoreUrl(window.location.href);

if (originalUrl) {
    window.location.href = originalUrl;
} else if (restoreUrl) {
    applyRestoreUrl(restoreUrl);
} else {
    const root = createRoot(document.getElementById('root'));
    root.render(<App />);

    initPiwik();
}